import React from 'react';
import { AiOutlineMail } from 'react-icons/ai';
import { FaCopy, FaDownload, FaLink, FaPrint } from 'react-icons/fa';

export const ShareButtons = [
  {
    icon: <FaLink className='icon' color='white' size='24px' />,
    type: 'link',
    title: 'Copy URL',
  },
  {
    icon: <FaCopy className='icon' color='white' size='24px' />,
    type: 'page',
    title: 'Copy Page Content',
  },
  {
    icon: <AiOutlineMail className='icon' color='white' size='24px' />,
    type: 'email',
    title: 'Share Page to Email',
  },
  {
    icon: <FaDownload className='icon' color='white' size='24px' />,
    type: 'download',
    title: 'Download Content',
  },
  {
    icon: <FaPrint className='icon' color='white' size='24px' />,
    type: 'print',
    title: 'Print Content',
  },
];
